module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABP0lEQVRoQ+2Yyw2DMBBEY0QfUTpICaSDlJATAgrid6GUKB2kBEogBSBiHyLlEol4ZwchrS9cvOt5M5a8wh12vtzO9R8MYOsELQFLQOiAXSGhgeJyS0BsobCBJfAxsOu66zzPQ5qmlzzPn0JjV5fDEmiaJvOn3pdlmZgQMIBgmYe4+c/AhIACbAEBB2BDqAAwIdQAWBCqAAwIdQBtCAqAJgQNQAuCCvAN4Zwbi6I4rZ4ZfmykAwQddV2PHuBYlqX4fHGDfx38GjceVVWF+Um0qAAf8d79V5IkGWJqpQFoiA/RUQC0xFMANMWrA2iLVwVgiFcDYIlXAWCKhwOwxUMBthAPBWjbdgoNUS/s2vkC9pD1fX/2P7YmP6CNaw9H7IMBIMTE9DCAGNeQNZYA0s2YXpZAjGvIGksA6WZMr90n8AYbjrwxW5YpNAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrowhead.png
// module id = QhEa
// module chunks = 1